import { Injectable, Injector, Optional } from '@angular/core';
import { EMPTY } from 'rxjs';
import { FormMessageService } from './form-message.service';
import { LanguageService } from './languag.service';
import { BefRepository } from '@farris/bef';
import { CommandContext, Entity, FrameContext } from '@farris/devkit';
import { CloudprintService, OutputOptions, SourceOptions, OutputType, FileType, SourceFilterOptions, PrintType } from '@gsp-svc/cloudprint';
import { FormNotifyService } from './form-notify.service';
// tslint:disable: unified-signatures
// tslint:disable: max-line-length
/**
 * æå°æå¡
 * @Scope FrameComponent
 */
@Injectable()
class PrintService {
  /**
   * å®ä½ä»åº
   */
  private repository: BefRepository<Entity>;

  /**
   * æé å½æ°
   */
  constructor(
    private msgService: FormMessageService,
    private languageService: LanguageService,
    private printService: CloudprintService,
    @Optional() private formNotifyService: FormNotifyService,
  ) {
  }

  /**
   * æå°åæ®
   * @param beMetaId BEåæ°æ®æ è¯
   * @param bizBillId ä¸å¡åæ®æ è¯
   */
  public printSingle(beMetaId: string, bizBillId: string) {
    if (!bizBillId) {
      // this.msgService.error(this.languageService.unallowEmptyBizBillId);
      this.showWarning(this.languageService.unallowEmptyBizBillId);
      return EMPTY;
    }
    return this.printArray(beMetaId, [bizBillId]);
  }
  /**
   * æå°åæ®ï¼éè¿idæidsï¼
   * @param beMetaId beåæ°æ®Id
   * @param ids åæ®idæids
   */
  public printByIds(beMetaId: string, ids: string) {
    if (!ids) {
      // this.msgService.error(this.languageService.unallowEmptyBizBillId);
      this.showWarning(this.languageService.unallowEmptyBizBillId);
      return EMPTY;
    }
    const dataIds: Array<string> = ids.split(',').filter(item => item);
    return this.printArray(beMetaId, dataIds);
  }
  /**
   * æå°åæ®ï¼å¸¦ç»´åº¦ï¼
   * @param beMetaId beåæ°æ®Id
   * @param ids åæ®idæids
   * @param dim1 ç»´åº¦1å¼
   * @param dim2 ç»´åº¦2å¼
   * @param billCategoryId åæ®ç±»åId
   */
  public printByIdsWithDimension(beMetaId: string, ids: string, dim1: string, dim2: string, billCategoryId?: string) {
    if (!ids) {
      // this.msgService.error(this.languageService.unallowEmptyBizBillId);
      this.showWarning(this.languageService.unallowEmptyBizBillId);
      return EMPTY;
    }
    const dataIds: Array<string> = ids.split(',').filter(item => item);
    return this.printArray(beMetaId, dataIds, dim1, dim2, billCategoryId);
  }
  /**
   * æå°å¤ä¸ªåæ®
   * @param beMetaId BEåæ°æ®æ è¯
   * @param dataIds ä¸å¡åæ®æ è¯æ°ç»
   * @param dim1 ç»´åº¦1
   * @param dim2 ç»´åº¦2
   * @param billCategoryId ä¸å¡åæ®ç±»åId
   */
  public printArray(beMetaId: string, dataIds: string[], dim1?: any, dim2?: any, billCategoryId?: string) {
    if (!dataIds || dataIds.length === 0) {
      // this.msgService.error(this.languageService.unallowEmptyBizBillId);
      this.showWarning(this.languageService.unallowEmptyBizBillId);
      return EMPTY;
    }
    const sourceOptions: SourceOptions = this.buildSourceOptions({
      dataIds: dataIds,
      sourceId: beMetaId
    });

    const outputOptions: OutputOptions = this.buildOutputOptions();

    if (typeof dim1 !== 'undefined') {
      sourceOptions.FirstDimensionVal = dim1;
    }
    if (typeof dim2 !== 'undefined') {
      sourceOptions.SecondDimensionVal = dim2;
    }
    if (typeof billCategoryId !== 'undefined') {
      sourceOptions.billCategoryId = billCategoryId;
    }
    return this.printService.outputBEData(sourceOptions, outputOptions, 'tab');
  }

  /**
   * æç§BEåæ°æ¹å¼æ¹éæå°åæ®
   * @param beMetaId BEåæ°æ®æ è¯
   * @param filterCondition è¿æ»¤æ¡ä»¶
   * @param sortCondition æåºæ¡ä»¶
   * @param includeChildData åå«å­è¡¨æ°æ®
   */
  public printMulti(beMetaId: string, filterCondition: string, sortCondition: string, includeChildData: boolean = true) {
    const entryFilter = { 'isUsePagination': false, 'filterConditions': [], 'sortConditions': [], 'pagination': null };
    if (filterCondition) {
      // ç»ä¸çº æ­£æåä¸ä¸ªè¿æ»¤æ¡ä»¶çRelation
      const filters = JSON.parse(filterCondition);
      if (filters && filters.length > 0) {
        filters[filters.length - 1].Relation = 0;
      }
      entryFilter.filterConditions = filters;
    }

    if (sortCondition) {
      entryFilter.sortConditions = JSON.parse(sortCondition);
    }
    // sfo:SourceFilterOptions
    const sourceFilterOptions: SourceFilterOptions = this.buildSourceFilterOptions({ sourceId: beMetaId, entryFilter, includeChildData });
    const outputOptions: OutputOptions = this.buildOutputOptions();
    return this.printService.outputBEDataWithFilter(sourceFilterOptions, outputOptions, 'tab');
  }
  /**
   * æç§BEåæ°æ¹å¼æ¹éæå°åæ®(å¸¦ç»´åº¦)
   * @param beMetaId BEåæ°æ®æ è¯
   * @param filterCondition è¿æ»¤æ¡ä»¶
   * @param sortCondition æåºæ¡ä»¶
   * @param dim1 ç»´åº¦1value
   * @param dim2 ç»´åº¦2value
   * @param billCategoryId ä¸å¡åæ®ç±»åId
   * @param includeChildData åå«å­è¡¨æ°æ®
   */
  public printMultiWithDimension(beMetaId: string, filterCondition: string, sortCondition: string, dim1: string, dim2: string, billCategoryId?: string, includeChildData: boolean = true) {
    const entryFilter = { 'isUsePagination': false, 'filterConditions': [], 'sortConditions': [], 'pagination': null };
    if (filterCondition) {
      // ç»ä¸çº æ­£æåä¸ä¸ªè¿æ»¤æ¡ä»¶çRelation
      const filters = JSON.parse(filterCondition);
      if (filters && filters.length > 0) {
        filters[filters.length - 1].Relation = 0;
      }
      entryFilter.filterConditions = filters;
    }

    if (sortCondition) {
      entryFilter.sortConditions = JSON.parse(sortCondition);
    }
    const sfo: SourceFilterOptions = this.buildSourceFilterOptions({ sourceId: beMetaId, entryFilter, includeChildData });
    if (typeof dim1 !== 'undefined') {
      sfo.FirstDimensionVal = dim1;
    }
    if (typeof dim2 !== 'undefined') {
      sfo.SecondDimensionVal = dim2;
    }
    if (typeof billCategoryId !== 'undefined') {
      sfo.billCategoryId = billCategoryId;
    }
    const outputOptions: OutputOptions = this.buildOutputOptions();
    return this.printService.outputBEDataWithFilter(sfo, outputOptions, 'tab');
  }
  /**
   * æé SourceOptions
   * @param options options
   */
  private buildSourceOptions(options: { dataIds: string[], sourceId: string, [prop: string]: any }): SourceOptions {
    const so: SourceOptions = {
      DataIds: options && options.dataIds || undefined,
      SourceId: options && options.sourceId || undefined,
      FirstDimensionVal: options && options.dim1 || undefined,
      SecondDimensionVal: options && options.dim2 || undefined,
      RetrieveParam: options && options.retrieveParam || undefined,
      FormatId: options && options.formatId || undefined,
      billCategoryId: options && options.billCategoryId || undefined,
      ServiceUnit: options && options.serviceUnit || undefined,
      currentPage: options && options.currentPage || undefined,
      pageRowCount: options && options.pageRowCount || undefined,
      queryType: options && options.queryType || undefined,
      queryServiceId: options && options.queryServiceId || undefined,
      queryParam: options && options.queryParam || undefined
    };
    return so;
  }
  /**
   * æé OutputOptions
   * @param options options
   */
  private buildOutputOptions(options?: { [prop: string]: any }): OutputOptions {
    const oo: OutputOptions = {
      OutputType: options && options.outputType || OutputType.PRINT,
      FileType: options && options.fileType || FileType.Html5,
      Path: options && options.path || undefined,
      DeviceId: options && options.deviceId || undefined,
      printJob: options && options.printJob || undefined,
      printerName: options && options.printerName || undefined,
      printSetting: options && options.printSetting || undefined,
      printType: options && options.printType || PrintType.Form
    };
    return oo;
  }
  /**
   * æé SourceFilterOptions
   * @param options options
   */
  private buildSourceFilterOptions(options: { sourceId: string, [prop: string]: any }): SourceFilterOptions {
    const entryFilter = { 'isUsePagination': false, 'filterConditions': [], 'sortConditions': [], 'pagination': null };
    const sfo: SourceFilterOptions & { [prop: string]: any } = {
      SourceId: options.sourceId,
      EntityFilter: options && options.entryFilter || entryFilter,
      FirstDimensionVal: options && options.dim1 || undefined,
      SecondDimensionVal: options && options.dim2 || undefined,
      FormatId: options && options.formatId || undefined,
      ServiceUnit: options && options.serviceUnit || undefined,
      billCategoryId: options && options.billCategoryId || undefined,
      currentPage: options && options.currentPage || undefined,
      pageRowCount: options && options.pageRowCount || undefined,
      queryParam: options && options.queryParam || undefined,
      queryServiceId: options && options.queryServiceId || undefined,
      queryType: options && options.queryType || undefined,
      includeChildData: options && options.hasOwnProperty('includeChildData') ? options.includeChildData : true
    };
    return sfo;
  }
  /**
   * å±ç¤ºéè¯¯æ¶æ¯
   * @param message éè¯¯æ¶æ¯
   */
  private showWarning(message: string) {
    if (this.notifyService) {
      this.notifyService.warning(message, { hideTitle: true });
    } else if (this.msgService) {
      this.msgService.error(message);
    }
  }
  private get notifyService(): FormNotifyService | null {
    if (this.formNotifyService) {
      return this.formNotifyService;
    } else if (this.injector) {
      return this.injector.get<FormNotifyService>(FormNotifyService, null);
    }
    return null;
  }
  private get commandContext(): CommandContext | null {
    return this['context'] || null;
  }
  private get frameContext(): FrameContext | null {
    return this.commandContext && this.commandContext.frameContext || null;
  }
  private get injector(): Injector | null {
    return this.frameContext && this.frameContext.injector || null;
  }
}

export { PrintService };
